<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش عملکرد ماهیانه </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- خطوط -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> خطوط </label>

            <select class="form-select" formControlName="iBusLine">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="" *ngFor="let item of lst_Lines" [value]="item.iBusLine">

                    {{ item.strBusLineName }}

                </option>

            </select>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-1 position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Report()">

                <small> جستجو </small>

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')">

                <small> &nbsp; خروجی اکسل &nbsp; </small>

            </button>

        </div>

    </form>

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                    (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 260px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>

                        <th class="text-center"> نام خط </th>

                        <th class="text-center"> راننده </th>

                        <th class="text-center"> پلاک </th>

                        <th class="text-center"> مدت حضور(h) </th>

                        <th class="text-center pointer" (click)="sortfKmTotal()">

                            <i class="fa fa-sort"></i>

                            پیمایش(km)

                        </th>

                        <th class="text-center"> تعداد روز </th>

                        <th class="text-center text-danger fw-bold pointer" (click)="sortfADT()">

                            <i class="fa fa-sort"></i>

                            کارایی

                        </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="">

                            <i class="fa fa-info-circle fs-5 pointer" title="مشخصات" (click)="openDetails(item)"></i>

                        </th>

                        <td [innerHTML]="highlightText(item.strBusLineName,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value) | faNum"> </td>

                        <td> {{ item.strVehicleNo | faNum }} </td>

                        <td> {{ item.fHours | faNum }} </td>

                        <td> {{ item.fKmTotal.toFixed(2) | faNum }} </td>

                        <td> {{ item.iDays | faNum }} </td>

                        <td [ngClass]="{'bg-success text-white': item.fADT > 60,'bg-light': item.fADT <= 60 && item.fADT >= 20,'bg-warning text-dark': item.fADT < 20}">

                            {{ item.fADT.toFixed(2) | faNum }}

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

        <div class="row gx-0 gy-0 p-2 bg-secondary">

            <span class="col-md-auto col-12 text-white">

                تعداد : {{ lst_Report.length | number:'1.0-0' | faNum }}

            </span>

            <span class="col-md-auto col-12 text-white mx-md-5">

                سرجمع پیمایش : {{ fKmTotal | number:'1.0-0' | faNum}} کیلومتر

            </span>

            <span class="col-md-auto col-12 text-white">

                متوسط کارایی : <span dir="ltr"> {{ (fADT) |number:'1.0-0' | faNum }} </span>

            </span>

        </div>

    </div>

</main>